import {Component, Provide, Vue, Watch} from "vue-property-decorator";
import {Getter} from "vuex-class";
import injectStyle from "~/modules/customisation/style-injector";
import {Sidebar} from "~/components/sidebar";
import {NotificationsZone} from "~/modules/notifications/components/notifications-zone";
import {hasClients} from "~/modules/partner/services";
import {AppSettings} from "~/lib/app-settings";
import {getClientDetails} from "~/modules/client/service";
import { StackSystem } from "~/components/stack-system";

export const rootStackSystem = new StackSystem();
@Component
class AppLayout extends Vue {

  @Getter customisationSchema;
  @Provide() appSettings: AppSettings = new AppSettings();
  @Provide() rootModalStack: StackSystem = rootStackSystem;

  mounted() {
    injectStyle(this.customisationSchema);
  }

  async created() {
    this.appSettings.hasClients = await hasClients();
  }

  get partnerUuid() {
    return this.$route.params.clientUuid;
  }

  @Watch('partnerUuid', { immediate: true })
  async onPartnerUuidChange(next) {
    this.appSettings.clientUUID = next || null;
    if (!this.appSettings.clientUUID) return null;

    try {
      this.appSettings.client = await getClientDetails(this.appSettings.clientUUID);
    } catch (err) {
      console.error(err);
      await this.$router.push({ name: 'partner_home' });
    }
  }

  render() {

    // Ensure client details when "partner" Mode
    if( this.appSettings.clientUUID && ! this.appSettings.client ){
      return null;
    }

    return (
      <div class={`app ${this.$isMobile() ? "is-mobile" : ""} `}>
        <Sidebar />
        <router-view />
        <NotificationsZone />
        {this.rootModalStack.$}
      </div>
    );
  }
}

export default AppLayout;


// VUE JSX HOT LOADER //
if (module.hot) require("/usr/src/app/node_modules/vue-jsx-hot-loader/src/api.js")({ Vue: require('vue'), ctx: eval('this'), module: module, hotId: "_vue_jsx_hot-4d01ec42/app-layout.tsx" });